export default __webpack_public_path__ + "static/media/charm-1.21bee8c4.png";